export default __webpack_public_path__ + "static/media/2.11bfde24.svg";